

(function( ){


//------------------------------------------------------------------------------------------------------------------------------


	var Main = function( )
	{
		var _this = this , i ;

		var _line = $('.line'),
				_lineTxt = encodeURIComponent('XFLAGが贈る、ゲーム・音楽・スポーツ…様々なステージやアトラクションが融合したLIVEエンターテインメント！ケタハズレを、超えて行け。2018年6月30日(土)・7月1日(日)@幕張メッセ国際展示場1-6ホール '),
				_lineUrl = encodeURIComponent('https://event-info.xflag.com/park/2018/');
				_lineShareforSP = 'http://line.me/R/msg/text/?' + _lineTxt + _lineUrl,
				_lineShareforPC = 'https://social-plugins.line.me/lineit/share?' + "url=" + _lineUrl + "&text=" + _lineTxt;

			//外部アンカーリンクズレ解消
			window.addEventListener('load',function(){
				// URLのアンカー（#以降の部分）を取得
				var urlHash = location.hash;
				var ary = ['#time-schedule_link' , '#game-show_link' , '#entertainment-show_link' , '#ticket-freak_link', '#sales-schedule_link' , '#sec-11_link' , '#ticket-premium_link' , '#main-dish_link' , '#light-meal_link' , '#sweets_link' , '#drink_link'],
				i = 0,
				len = ary.length;
				for (i = 0; i < len; i++) {
					if(urlHash){
						if (urlHash == ary[i]) {
							var link = ary[i].split('_');
							setTimeout(function(){
								var _targetPosition = $(link[0]).offset().top,
								_zoomNumber     = window.Fit.zoomScale;
								$('html,body').animate({
									scrollTop: _targetPosition * _zoomNumber
								},500);
							},700);
						} else{}
					}
				}
			});



		//UA判別
		var ua = navigator.userAgent;
		if(ua.indexOf('iPhone') > 0 || ua.indexOf('iPod') > 0 || ua.indexOf('Android') > 0 && ua.indexOf('Mobile') > 0){
			$('html').addClass('is__SP');
			_line.attr("href", _lineShareforSP);
		}else if(ua.indexOf('iPad') > 0 || ua.indexOf('Android') > 0){
			$('html').addClass('is__Tab');
			_line.attr("href", _lineShareforSP);
		}else{
			$('html').addClass('is__PC');
			_line.attr("href", _lineShareforPC);
		}

		//横幅判別
		function _isPC_width(){
			$('html').addClass('width-pc').removeClass('width-sp');
		}
		function _isSP_width(){
			$('html').addClass('width-sp').removeClass('width-pc');
		}
		if (window.matchMedia("(max-width: 736px)").matches) {
			_isSP_width();
		} else {
			_isPC_width();
		}

		//ナビケーション表示出し分け　読み込み時
		$(window).on('load',function(){
			if($('html').hasClass('is__Tab')){
				spNav();
			}else if($('html').hasClass('width-sp')){
				spNav();
			}else{
				pcNav();
			}
		});
		//ナビケーション表示出し分け　画面リサイズ時
		function matchFunction() {
			if (window.matchMedia("(min-width: 737px)").matches) {
				_isPC_width();
				pcNav();
			}else if(window.matchMedia("(max-width: 736px)").matches){
				_isSP_width();
				spNav();
			}
		}
		window.matchMedia("(max-width: 736px)").addListener(matchFunction);


		/*=================================
		PC Nav settings
		=================================*/
		var _header = $('.header');
		$(window).scroll(function(){
			var _headerY = _header.outerHeight(), _scrollY = $(window).scrollTop();
			if(_headerY < _scrollY){
				$('.header').addClass('scroll');
				if($('body').hasClass('top')){
					$('.header').addClass('toppage-header');
				}
			}else{
				$('.header').removeClass('scroll scroll-pc')
			}
		});
		if($('body').hasClass('top')){
			_header.removeClass('header-border')
		}else{
			_header.addClass('header-border')
		}

		/*=================================
		Nav settings
		=================================*/

		var _nav = $('nav'),_navList = $('.nav-list').not('.nav-list .drop-menu a'), next = '.drop-menu',_dropMenu = $('.drop-menu'),_dropMenuLink = $('.drop-menu a');

		//ナビゲーション PC表示制御
		function pcNav(){
			_nav.css('display','table');
			_dropMenu.css('display','none');

			_navList.on("mouseenter",function(){
				if($('html').hasClass('is__PC width-pc')){
					$(this).children(next).stop().fadeIn(300);
				}
			});
			_navList.on("mouseleave",function(){
				if($('html').hasClass('is__PC width-pc')){
					$(this).children(next).stop().fadeOut(100);
				}
			});
			//グロナビカレント表示
			$(document).ready(function() {
					var activeUrl = location.pathname.split("/")[3],
							navList = _nav.find("a");
					navList.each(function(){
						if( $(this).attr("href").split("/")[3] == activeUrl ) {
							$(this).addClass("active");
							$(this).prevAll().removeClass('active');
							$(this).nextAll().removeClass('active');
						}
					});
				});
		}

		//ナビゲーション SP&Tab表示制御
		function spNav(){
			_nav.css('display','none');
			_dropMenu.css('display','block');
			_tglMenu.removeClass('active');
		}

		//ドロップメニューアンカーリンク用設定
		_dropMenuLink.click(function(){
			if($('html').hasClass('is__PC width-pc')){
				_dropMenu.fadeOut(100);
			}
		});

		//SP&Tabトグルメニュー用設定
		var _tglMenu = $('.toggle-menu');
		_tglMenu.click(function(){
			_dropMenu.css('display','block');
			if ($(this).hasClass('active')) {
				$(this).removeClass('active');
				_nav.fadeOut('300');
			}else{
				$(this).addClass('active');
				_nav.fadeIn('300');
			}
		})
		/*=================================
		SP button effect
		=================================*/
		var _spBtnTarget = $('.sp-btn-ef');
		_spBtnTarget.bind('touchstart', function() {
			$(this).addClass('active');
		}).bind('touchend', function() {
			$(this).removeClass('active');
		});

		/*=================================
		PC pagetop effect
		=================================*/
		var _pageTop = $('.page-top');

		_pageTop.on("mouseenter",function(){
			$(this).addClass('active');
		});
		_pageTop.on("mouseleave",function(){
			$(this).removeClass('active');
		});

		$(window).scroll(function(){
			var scroll = $(window).scrollTop();
			if(scroll > 200){
				_pageTop.fadeIn();
			}else{
				_pageTop.fadeOut();
			}
		});


		/*=================================
		Scroll Fixed header for FitContents
		=================================*/
		var _secHeader = $('.sec-header'),
			_fixedHeader = $('.fixed-header');


			$(window).scroll(function(){
				var scroll = $(window).scrollTop();
				var _gNavHeight = $('.header')[0].clientHeight*Fit.zoomScale;

				_secHeader.each(function(){
					var _$this = $(this),
						_this = this,
						_$target = _$this;
						_secHeader_offTop = Math.floor(_this.offsetTop)*Fit.zoomScale,
						_secHeaderHeight  = _this.clientHeight*Fit.zoomScale;
						_fixHeaderHeight = _fixedHeader[0].clientHeight*Fit.zoomScale;
					if(_secHeader_offTop <= scroll + _gNavHeight + _fixHeaderHeight ) {
						_fixedHeader.css('visibility','hidden');
						if(scroll >= _secHeader_offTop - _gNavHeight){
							_$target.addClass('pos-fix');
							_fixedHeader.css('visibility','visible');
						}
					}else{
						_$target.removeClass('pos-fix').css('visibility','visible');
					}

					if($('body').hasClass('stage')){
						_fixedHeader.show()
						if(_$target.hasClass('pos-fix')){
							if(_$target.hasClass('game-header')){
								_fixedHeader.addClass('game-fixedheader').removeClass('entertainment-fixedheader');
								$('.entertainment-fixedheader').css('visibility','hidden');
							}else if(_$target.hasClass('enter-header')){
								_fixedHeader.addClass('entertainment-fixedheader').removeClass('game-fixedheader');
							}
						}
					} else if (_$target.hasClass('pos-fix')){
						var _txt = _$target.text();
						_fixedHeader.show().text(_txt);
					}

					if(Math.floor(_secHeader[0].offsetTop)*Fit.zoomScale > scroll + _gNavHeight + _fixHeaderHeight){
						_fixedHeader.css('visibility','hidden');
					}
				});
				return;
			});

			/*=================================
			クリック判定
			=================================*/
			var _clickElm = $('.click-ef')
			_clickElm.click(function (){
				if($(this).hasClass('active')){
						$(this).removeClass('active');
				}else{
					$(this).addClass('active');
				}
			});

			/*=================================
			aタグhover
			=================================*/
			var _hover = $('.hover_effect'),
			_actionStart = ((window.ontouchstart !== null) ? 'mouseenter' : 'touchstart'),
			_actionEnd = ((window.ontouchstart !== null) ? 'mouseleave' : 'touchend');

			_hover.on(_actionStart,function(){
				$(this).stop().animate({
					opacity: '0.5'
				},100)
			});

			_hover.on(_actionEnd,function(){
				$(this).stop().animate({
					opacity: '1'
				},100)
			});


		//	-	-	-	-	-	-	-	-	-	-	-	-	-	-	-	-	-	-	-

		// リサイズイベントを使うときは、この_onResize内に処理を書いてください。
		// リサイズイベントを綱わないようでしたら決してください。
		// var _onResize = function( )
		//{
		//}

		// _onResize( ) ;
		// FitContents.addTask( _onResize ) ;
	}


//------------------------------------------------------------------------------------------------------------------------------


	window.requestAnimationFrame = 	window.requestAnimationFrame ||
									window.webkitRequestAnimationFrame ||
									function( func ){ return setTimeout( func , 1000/60 ) ; } ;


	window.cancelAnimationFrame = 	window.cancelAnimationFrame ||
									window.webkitCancelAnimationFrame ||
									function( id ){ clearTimeout( id ) ; } ;


	document.readyState === "complete"
		? setTimeout( function(){ new Main( ) ; } , 1 )
		: document.addEventListener( "DOMContentLoaded", function(){ new Main( ) ; } ) ;


//------------------------------------------------------------------------------------------------------------------------------


} )( ) ;
